export default "__VITE_ASSET__BMx6g1jO__"